import { g17ecoApi } from '@api/g17ecoApi';
import type { ApiResponse } from '@g17eco/types/api';

interface BulkVerifyUtrvParams {
  surveyId: string;
  utrvIds: string[];
}

export interface BulkVerifyUtrvResponse {
  total: number;
  verified: number;
  skipped: number;
  errored: number;
}

const getUrl = (surveyId: string) => `/surveys/${surveyId}/universal-tracker-values`;

export const surveyUtrvsApi = g17ecoApi.injectEndpoints({
  endpoints: (builder) => ({
    bulkVerifyUtrvs: builder.mutation<ApiResponse<BulkVerifyUtrvResponse>, BulkVerifyUtrvParams>({
      query: ({ surveyId, utrvIds }) => ({
        url: `${getUrl(surveyId)}/bulk-verify`,
        method: 'post',
        data: { utrvIds },
      }),
    }),
  }),
});

export const { useBulkVerifyUtrvsMutation } = surveyUtrvsApi;
